import { render } from "./SubAreas.vue?vue&type=template&id=5a6100c5&scoped=true"
import script from "./SubAreas.vue?vue&type=script&scoped=true&lang=js"
export * from "./SubAreas.vue?vue&type=script&scoped=true&lang=js"

import "./SubAreas.vue?vue&type=style&index=0&id=5a6100c5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6100c5"]])

export default __exports__